import { ReactComponent as AddToDash } from 'assets/icons/icon-add-to-dash.svg';

export default AddToDash;
